import BaseDialog from '@/components/BaseDialog'
import { delErrList, delErrGroupList } from './utils'

/**
 * 批量选择
 * @param {*} param0 
 * @returns 
 */
export function batchSelectModal({ props, cbs, title ,options = {} }) {
        
    return {
        ...new BaseDialog({
            component: ()=>import('./batchSelectModal'),
            options: {
                width: '600px',
                title,
                closeOnPressEscape:false,
                closeOnClickModal:false,
                showClose: false,
                ...options
            },
            props,
            cbs,
        }),
        delErrList,
        // 「未找到」按状态归类的弹框（2026-07-22）。仅排单/指派/任务的 work_order 批量查询用；
        // 后端没回 err_groups 时调用方退回 delErrList，行为与改动前完全一致。
        delErrGroupList
    }
}